'use client';

import { InstamenuAPIProvider } from '@instamenu/context-api';
import { AuthProvider } from '@instamenu/context-firebase';
import { UserProvider } from '@instamenu/context-user';
import { LocaleProvider } from '@instamenu/context-i18n';
import { Toaster } from 'react-hot-toast';
import { APIProvider } from '@vis.gl/react-google-maps';

export function Providers({ children }: { children: React.ReactNode }) {
  if (!process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY)
    throw new Error('Google Maps API key is not set');

  return (
    <LocaleProvider>
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
      <AuthProvider>
        <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY} libraries={['places']}>
          <InstamenuAPIProvider endpointOverride="/stats/graphql">
            <UserProvider loadPaymentMethods={false}>{children}</UserProvider>
          </InstamenuAPIProvider>
        </APIProvider>
      </AuthProvider>
    </LocaleProvider>
  );
}
